var DrawableNote = require('../base'),
    BaseShapeView = require('../../../../../../canvas/views/shape/shape');

/*
* Coordinate refers to page notes stored in FDD Graphic Object Files in Edstor: highlights, redactions, strikethroughs
* */

module.exports = DrawableNote.extend({

    defaultSubType: 'rect',

    defaultFillOpacity: 0.25, // TODO: move to shape models ?

    shapeModelsToRender: function(page) {

        var ShapeModelConstructor = this.getShapeModel();

        return _.map( this.get('shapes'), function(attrs, i) {

            return new ShapeModelConstructor( attrs, {
                parentNote: this,
                pageModel: page,
                shapeIndexOfNote: i,
                isConvertingToFloatingCodes: this.isConvertingToFloatingCodes // this should just be on redaction shape ( but wont hurt highlights ) ...
            });

        }, this);

    },
    shapeView: function(options) {
        return new BaseShapeView(options);
    },
    hasShapes: function() {
        return this.get('shapes').length > 0; //shape will be empty array w/out
    },

    // --- Would want to move these to shape models ( but kinda difficult since newly drawn shapes don't have a model ) ---

    /**
     * Central point for getting the 'default' Raphael attributes to apply to notes' shapes.
     * Now called centrally from canvas.getAttributesToApplyToShapeEl,
     * which calls canvas.getColorToApplyToShape, which is the color parameter passed here.
     */
    defaultSVGAttrs: function( color ) {

        color = color ? color : this.getDefaultShapeColor();

        var opacity = this.getDefaultFillOpacity();

        return {
            stroke: color,
            fill: color,
            'stroke-width': 0,
            'fill-opacity': opacity
        };

    },


    defaultSVGAttrsEdit: function( color ) {

        return _.extend(
            {},
            this.defaultSVGAttrs( color ),
            { 'stroke-width': 2 }
        );

    },

    getDefaultFillOpacity: function() {
        return this.defaultFillOpacity;
    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/notes/models/page/noteTypes/drawable/coordinate/base.js
 ** module id = 150
 ** module chunks = 0
 **/